/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_ContinueInputs */

const en_us2_profile_editors_continue = /** @type {(inputs: Profile_Editors_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const pt_br2_profile_editors_continue = /** @type {(inputs: Profile_Editors_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const es_419_profile_editors_continue = /** @type {(inputs: Profile_Editors_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const pt_pt2_profile_editors_continue = /** @type {(inputs: Profile_Editors_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const fr_fr2_profile_editors_continue = /** @type {(inputs: Profile_Editors_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer`)
};

const de_de2_profile_editors_continue = /** @type {(inputs: Profile_Editors_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiter`)
};

const it_it2_profile_editors_continue = /** @type {(inputs: Profile_Editors_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Profile_Editors_ContinueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_continue = /** @type {((inputs?: Profile_Editors_ContinueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_ContinueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_continue(inputs)
	if (locale === "es-419") return es_419_profile_editors_continue(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_continue(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_continue(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_continue(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_continue(inputs)
	return en_us2_profile_editors_continue(inputs)
});
export { profile_editors_continue as "profile-editors.continue" }